module.exports = __webpack_public_path__ + "static/media/GreenCheck.52a90f3f.svg";